<script>
	import { link } from 'svelte-routing';
	import Strapi from "strapi-sdk-javascript";
	import MainContent from "../../components/MainContent.svelte";
	import SideNavBar from "../../components/SideNavBar.svelte";
	import { onMount } from "svelte";
	import jwt_decode from "jwt-decode";
	import { strapi_api } from "../../utils/config";
	let fetch = window.fetch;


	let showChapters = false;

	let books = [];
	
	if (localStorage.jwt) {
		// Set auth token header auth
		const token = localStorage.jwt;
		const decoded = jwt_decode(token);
		const currentTime = Date.now() / 1000; // to get in milliseconds
		if (decoded.exp < currentTime && decoded) {
			store.dispatch(logoutUser());
			window.location.href = "/";
		}
	} else {
		window.location.href = "/";
	}

	const strapi = new Strapi(strapi_api);

	onMount(async () => {
		jQuery.ajax({
            url: strapi_api+'/books/user/'+localStorage.getItem("userid"),
            type: 'get',
            dataType: 'json',
            headers: {
            	'Authorization': 'Bearer '+localStorage.getItem("token"),
            },
            contentType: 'application/json',
            success: function (response) {
				books = response;
            },
        })

	});
	
</script>

<div class="container-fluid p-0 ">
	<SideNavBar activeClass="books" />
	<MainContent header={"Books"}>
		{#if !showChapters}
			<div class="row books-container">
				{#each books as book}
					<div class="col-lg-2 col-md-2 mb-4">
						 <a class="nav-link d-flex align-items-center border-none" href="/books/{book.id}" use:link>
						<div class="card" >
							<div class="card-body p-0 pointer book">
								<img
									width="100%"
									src={strapi_api + "/uploads/"+book.image}
									alt={book.image}
								/>
							</div>
							<div class="title-holder">
								<span>
									{book.name.replaceAll('_', " ")}
								</span>
							</div>
						</div>
						</a>
					</div>
				{/each}
			</div>
		{/if}
	</MainContent>
</div>

<style>
	.title-holder{
		background: transparent !important;
		text-align: center;
		margin-top: 5px;
		padding: 10px 5px;
		font-size: 16px;
	}
	
</style>